export const teamsKeys = {
  all: [{ module: 'teams' }] as const,

  lists: () => [{ ...teamsKeys.all[0], scope: 'list' }] as const,
  listsByOrganization: (organizationId: string) => [{ ...teamsKeys.lists()[0], organizationId }] as const,

  adminDetails: () => [{ ...teamsKeys.all[0], scope: 'adminDetail' }] as const,
  adminDetail: (organizationRoleId: string) => [{ ...teamsKeys.adminDetails()[0], organizationRoleId }] as const,

  details: () => [{ ...teamsKeys.all[0], scope: 'detail' }] as const,
  detail: (organizationRoleId: string) => [{ ...teamsKeys.details()[0], organizationRoleId }] as const,
  detailBySlug: (organizationId: string, slug: string) =>
    [{ ...teamsKeys.details()[0], organizationId, slug }] as const,

  availableMembers: () => [{ ...teamsKeys.all[0], scope: 'availableMembers' }] as const,
  availableMembersByTeam: (organizationRoleId: string) =>
    [{ ...teamsKeys.availableMembers()[0], organizationRoleId }] as const,
};
